<template>
  <div class="p-5">
    <h5> زمان های اعتبار</h5>
    <div class="d-flex flex-wrap mt-5">
      <select v-model="validTime.dayNum" class="mr-2 week-date-select">
        <option v-for="(date,i) in weekDates" :value="i" v-text="date"></option>
      </select>
      <persian-date-picker :autoSubmit="true" type="time" class="mr-3"
                           v-model="validTime.time"></persian-date-picker>
      <feather-icon @click="addValidTime" class="cursor-pointer text-success" icon="PlusSquareIcon"
                    svgClasses="w-10 h-10 hover:stroke-current"/>
    </div>
    <div v-if="validTimes.length" class="mt-5">
      <vs-table noDataText="موردی اضافه نشده" stripe :data="validTimes">
        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.dayNum">
              {{weekDates[tr.dayNum]}}
            </vs-td>
            <vs-td :data="tr.hour">
              <div style="display: inline-block;direction: ltr">
                {{timeFormat(tr.hour,tr.min)}}
              </div>
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <feather-icon class="cursor-pointer" @click="removeValidTime(tr)" icon="TrashIcon"
                            svgClasses="w-5 h-5 hover:text-danger stroke-current"/>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";

  export default {
    name: "ValidTimes",
    data() {
      return {
        weekDates: ['شنبه', 'یک شنبه', 'دو شنبه', 'سه شنبه', 'چهار شنبه', 'پنج شنبه', 'جمعه'],
        validTime: {
          dayNum: 0,
          time: '07:00',
        }
      }
    },
    methods: {
      timeFormat(hour, min) {
        hour = hour.toLocaleString().length === 1 ? '0' + hour : hour
        min = min.toLocaleString().length === 1 ? '0' + min : min
        return hour + ' : ' + min
      },
      addValidTime() {
        if (this.validTime.dayNum === "" || !this.validTime.time)
          return;
        let hour = Number(this.validTime.time.split(':')[0])
        let min = Number(this.validTime.time.split(':')[1])
        let vtExist = this.validTimes.find(i => {
          return i.dayNum === this.validTime.dayNum && i.hour === hour && i.min === min
        })
        if (vtExist) {
          alert('این زمان قبلا اضافه شده')
          return;
        }

        this.validTimes = {
          action: 'add',
          taskId: this.taskId,
          item: {
            dayNum: this.validTime.dayNum,
            hour: Number(hour),
            min: Number(min),
          }
        }

      },
      removeValidTime(vt) {
        this.validTimes = {
          action: 'remove',
          taskId: this.taskId,
          item: vt
        }
      }
    },
    mounted() {
    },
    computed: {
      validTimes: {
        get() {
          return this.$store.state.task.validTimes
        },
        set(value) {
          this.$store.dispatch('saveValidTimes', value)
        }
      }
    },
    props: {
      taskId: [Number],
    }
  }
</script>

<style scoped>
  .week-date-select {
    height: 43px;
    border-radius: 4px;
    border: 1px solid #dcdcdc;
  }
</style>
